import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          setError('Session ID non trouvé');
          setTimeout(() => navigate('/admin/login'), 2000);
          return;
        }

        // Exchange session_id for session_token
        const response = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          throw new Error('Échec de l\'authentification');
        }

        const userData = await response.json();
        
        // Navigate to admin dashboard with user data
        navigate('/admin', { state: { user: userData }, replace: true });
      } catch (err) {
        console.error('Auth error:', err);
        setError(err.message || 'Erreur d\'authentification');
        setTimeout(() => navigate('/admin/login'), 2000);
      }
    };

    processAuth();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFDF7]">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-2">Erreur</div>
          <p className="text-[#645E55]">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFDF7]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#db3b17] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#645E55] font-medium">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
